import React from "react";
import { Card, CardContent, Typography, Divider } from "@material-ui/core";

const DppSection = ({ header, children }) => (
  <Card variant="outlined" style={{ marginBottom: 16 }}>
    <CardContent>
      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
        {header}
      </Typography>
      <Divider style={{ margin: "8px 0 12px" }} />
      <div>
        {children || (
          <Typography variant="body2" color="textSecondary">
            Not available
          </Typography>
        )}
      </div>
    </CardContent>
  </Card>
);

export default DppSection;
